<template>
  <div>
    <div class="row d-flex justify-content-between mt-4 " v-if="registerProposal == false">
      <div class="col-9">
        <h2 class="mb-2">Propostas</h2>
        <h5 class="card-title text-uppercase text-muted mb-4 h5">propostas de crédito</h5>
      </div>
      <base-button
        @click="newProposal"
        type="success"
        size="sm"
        class="mr-3"
        style="max-height: 40px;"
        v-if="approval == false && createProposal"
      >
        <i class="fa fa-plus mt-2"></i>
        Nova Proposta
      </base-button>
    </div>

    <div v-if="registerProposal == true" class="col-12">
      <proposal-form
        :proposal.sync="proposal"
        :authorized="proposal.proposal_analyses_attributes && proposal.proposal_analyses_attributes.length > 0 ? proposal.proposal_analyses_attributes[0].authorized : false"
        :justification="proposal.proposal_analyses_attributes && proposal.proposal_analyses_attributes.length > 0 ? proposal.proposal_analyses_attributes[0].justification : ''"
        :cultures="proposal.culture_attributes"
        :clients="clients"
        :client="client"
        :disabled.sync="disabled"
        :notEdit="notEdit"
        @update-proposals="update"
        @registerProposal="registerProposal = false"
        @on:changed="$emit('on:changed')"
        :approval.sync="approvalData"
      ></proposal-form>
    </div>

    <div v-else>
      <el-table
        class="table-responsive clickable-rows"
        :border="true"
        :data="paginated_data"
        :stripe="true"
        :fit="true"
        v-loading="loadProposals"
      >
        <el-table-column min-width="100px" label="Número" prop="id" sortable />
        <el-table-column min-width="350px" label="Autor" prop="author" sortable/>
        <el-table-column min-width="350px" label="Cliente" prop="client.name" sortable/> 
        <el-table-column min-width="150px" label="Etapa" prop="stage" sortable />
        <el-table-column min-width="300px" label="Ano Safra" prop="anosafra.descricao" sortable />
        <el-table-column min-width="180px" label="Data de Abertura" v-slot="{ row }" sortable> {{ row.created_at | formatDate }}</el-table-column>
        <el-table-column 
          label="Status" 
          prop="status" 
          sortable
          min-width="120px"
          :filter-method="filterTag"
          :filters="[
            { text: 'Aprovada', value: 'approved' },
            { text: 'Em análise', value: 'analyse' },
            { text: 'Reprovada', value: 'disapproved' }
          ]"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              :type="getColor(scope.row.status).color"
              disable-transitions
            >
              {{ getColor(scope.row.status).value }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Ações" v-slot="{ row }">
          <el-dropdown
            trigger="hover"
            class="dropdown"
            style="cursor: pointer;"
          >
            <span class="btn btn-sm btn-icon-only text-blue">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <a class="dropdown-item" style="cursor: pointer;" @click="edit(row)">Editar</a>
              <a class="dropdown-item" style="cursor: pointer;" @click="remove(row)">Excluir</a>
              <a 
                v-if="row.client && row.client.cpf"
                class="dropdown-item"
                style="cursor: pointer;"
                @click="$router.push({
                  name: 'Ficha Cadastral PF',
                  params: { client: row.client, region: row.client.region }
                })">Ficha Cadastral
              </a>
              <a 
                v-else
                class="dropdown-item"
                @click="$router.push({
                  name: 'Ficha Cadastral PJ',
                  params: { client: row, region: row.client && row.client.region }
                })">Ficha Cadastral
              </a>
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </el-table>
      <div class="card-footer py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="getProposals"
          v-model="current"
          :total="this.proposals.length"
          :perPage="10"
        >
        </base-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { 
  Table, 
  TableColumn, 
  Tag,
  Dropdown,
  DropdownMenu,
  DropdownItem
}from "element-ui";

import swal from 'sweetalert2';
import ProposalForm from '../components/ProposalForm.vue'

export default {
  name: 'proposal',
  components: { 
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
    [Tag.name]: Tag,
    ProposalForm,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    client: {
      type: Object
    },
    clients: {
      type: Array,
      default: () => []
    },
    createProposal: {
      type: Boolean,
    },
    proposals: {
      type: Array,
    },
    approval: {
      type: Boolean
    },
    responsibleId: {
      type: Number
    },
    loadProposals: {
      type: Boolean
    },
    notEdit: {
      type: Boolean
    }
  },
  data () {
    return {
      current: 1,
      count: this.proposals.length,
      disabled: false,
      registerProposal: false,
      proposal: {
        culture_attributes: [
          {
            name: '',
            solicited_value: null
          }
        ],
      },
      users: [],
      user: this.$currentUser()
    }
  },
  methods: {
    checkingResponsible (proposal) {
      const validResponsible = proposal.responsible_proposals_attributes.filter(responsible => responsible.user_code == this.user.id)[0]
      if (validResponsible && validResponsible.id) {
        this.proposal.proposal_analyses_attribute = this.proposal.proposal_analyses_attributes.filter(analyse => analyse.responsible_proposal_id == validResponsible.id)[0]
        this.approvalData = true
        if (!this.proposal.proposal_analyses_attribute) {
          this.proposal.proposal_analyses_attribute = {
            authorized: false,
            justification: '',
          }
        }
      } else {
        this.proposal.proposal_analyses_attribute = {
          authorized: false, 
          justification: ''
        }
        this.approvalData = false
      }
    },
    edit(proposal) {
      this.proposal = proposal
      this.proposal.coin = { title: proposal.coin, name: proposal.coin == 'real' ? 'Real' : 'Dólar' }
      this.getProposalRoles(proposal.id)
      this.getProposalCultures(proposal.id)

      this.registerProposal = true
      this.disabled = true
    },
    filterTag(value, row) {
      return row.status === value
    },
    formatDate(dateString) {
      let dateParts = dateString.split(" / ")
      const finalString = '' + dateParts[1] + '-' + dateParts[0]
      if (dateParts.length > 2) finalString += '-' + dateParts[2]
      return finalString
    },
    getColor (status) {
      if (status == 'analyse') return {
        color: 'blue',
        value: 'Em análise'
      }
      else if (status == 'approved') return  {
        color: 'success',
        value: 'Aprovada'
      }
      else return {
        color: 'danger',
        value: 'Reprovada'
      } 
    },
    getProposals() {
      const data = {
        query: this.client && this.client.id ? { client_id: this.client.id} : {},
        page: this.current,
        per_page: 10,
        responsible_id: this.responsibleId
      }

      this.$http.secured.get("/api/v1/credit_analysis/get_proposals", { params: data })
        .then((response) => {
          this.paginated_data = response.data
          this.paginated_data.map(proposal => proposal.validity_date = new Date(`${proposal.validity_date}T00:00`))
        })
        .catch((error) => console.error(error, "Something went wrong"))
    },
    getProposalRoles(proposal_id) {
      this.$http.secured.get("/api/v1/credit_analysis/get_responsible_proposals", { params: {proposal_id: proposal_id }})
        .then((response) => {
          this.proposal.responsible_proposals_attributes = response.data
          this.proposal.roles = this.proposal.responsible_proposals_attributes.map(responsible => {
            return {
              description: responsible.role.description,
              id: responsible.role.id,
              user: responsible.user,
              responsible_id: responsible.id
            }
          })
          this.checkingResponsible(this.proposal)
        })
        .catch((error) => console.error(error, "Something went wrong"))
    },
    getProposalCultures(proposal_id) {
      this.$http.secured.get("/api/v1/credit_analysis/get_cultures", { params: { client_id: '', proposal_id: proposal_id } })
        .then((response) => {
          console.log("proposal_cultures: ", response.data)
          const cultures_attributes = response.data.map(culture => {
            return {
              name: culture.culture || culture.name,
              solicited_value: culture.solicited_value,
              id: culture.id
            }
          })
          
          this.proposal = Object.assign({}, this.proposal, { culture_attributes: cultures_attributes })
        })
        .catch((error) => console.error(error, "Something went wrong"))
    },
    newProposal() {
      this.disabled = false
      this.registerProposal = true
      this.proposal = {}
      this.proposal.culture_attributes = [{ solicited_value: null, name: ''}]
      this.proposal.proposal_analyses_attribute = {
        authorized: false,
        justification: '',
      }
    },
    remove(proposal) {
      const result = swal.fire({
        title: `Excluir proposta #${ proposal.id }?`,
        text: `Remover solicitação de crédito para a proposta #${ proposal.id }`,
        showCancelButton: true,
        confirmButtonColor: '#F5365C',
        cancelButtonColor: '#8898aa',
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Voltar',
      }).then( async (result) => {
        if (result.isConfirmed) {
          await this.$http.secured.delete("/api/v1/credit_analysis/delete_proposals", { params: {id: proposal.id} })
          this.proposals = this.proposals.filter(p => p.id != proposal.id)
        }
      })
    },
    update(value) {
      const updateProposal = this.proposals.filter(proposal => proposal.id == value.id)
      if (updateProposal.length) {
        this.proposals = this.proposals.filter(proposal => proposal.id !== updateProposal[0].id)
      }
      this.proposals.push(value)
    }
  },
  computed: {
    approvalData: {
      get () {
        return this.approval || false
      },
      set (approval) {
        this.approval = approval
        this.$emit('update:approval', approval)
      }
    },
    paginated_data: {
      get () {
        return this.proposals || false
      },
      set (proposals) {
        this.proposals = proposals
        this.$emit('update:proposals', proposals)
      }
    }
  }
}
</script>
<style>
  .cell{
    display: flex;
    justify-content: center;
    font-size: 11px;
  }

  .el-table-column--selection .cell, .cell {
    min-width: 100px;
    overflow: visible;
    text-overflow: initial;
    padding-left: 0px;
    padding-right: 0px;
  }  
  </style>
